import { SN_FOUNDATION_DATE } from './constants'

export const getYearsSinceSNWasFounded = (): number => {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()

  const yearsDiff = currentYear - SN_FOUNDATION_DATE.year

  // JS months start from `0`, thus we add `1`
  // If less than 6 months left until the company's foundation month, we round the year up.
  // (e.g., if currently it's April 2021, then it's 4 years. But starting from May, we show 5 years)
  const monthsDiff = Math.abs(currentMonth + 1 - SN_FOUNDATION_DATE.month)

  return monthsDiff <= 6 ? yearsDiff : yearsDiff - 1
}
